import { SearchRangeResponseApiModel } from '../../../api/mercury/model/search-range-response-api.model';
import moment from 'moment-timezone';

export class SearchRangeModel {
    from: Date;
    to: Date;

    constructor(apiModel?: SearchRangeResponseApiModel) {
        if (apiModel) {
            if (apiModel.items && apiModel.items.length >= 1) {
                // Shift the date to midnight of the day returned in UTC time, time should always be midnight
                const momentFrom = moment(apiModel.items[0].createdFrom);
                this.from = momentFrom.add(-1 * momentFrom.utcOffset(), 'minutes').toDate();
                // Shift the date
                this.to =  new Date(apiModel.items[0].createdTo);
            }
        } else {
            this.from = null;
            this.to = null;
        }
    }
}
